let GoogleLoginBtn
if (process?.env?.REACT_APP_CORDOVA) {
  GoogleLoginBtn = require('./GoogleLoginBtn.cordova.js').default
} else {
  GoogleLoginBtn = require('./GoogleLoginBtn.js').default
}
export default GoogleLoginBtn